import { Modal, ModalHeader, ReactForm, ModalBody, Section, SelectField, ModalFooter, Button } from "mta-rkvr-styles";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { get, post } from "../api/fetch";
import { UserInterestAreaRequestBody } from "../api/NotificationsSubscriptionsRequestTypes";
import {
  AdsBoroughResponseBody,
  AdsCountyResponseBody,
  AdsVillageResponseBody,
} from "../api/NotificationsSubscriptionsResponseTypes";
import { Input, InputName } from "../types/notificationsSubscriptions/AddInterestArea";
import { SelectReference } from "../types/util/RefTypes";
import { Classifier } from "../util/classifierManager";
const AddInterestAreaModal: React.FC<{
  isOpen: boolean;
  open: Function;
  refresh: Function;
}> = ({ isOpen, open, refresh }) => {
  const { t } = useTranslation();
  const tBase = "notificationsSubscriptions.areasOfInterest.add.";

  function close() {
    open();
  }

  const [counties, setCounties] = useState<Classifier[]>();
  const [boroughs, setBoroughs] = useState<Classifier[]>();
  const [villages, setVillages] = useState<Classifier[]>();

  const boroughRef = useRef<SelectReference>();
  const villageRef = useRef<SelectReference>();

  useEffect(() => {
    get<AdsCountyResponseBody>({
      endPoint: "ads",
    }).then(
      (res) =>
        res.ok &&
        setCounties(
          res.body.resultsList.map((maakond) => {
            return {
              label: maakond.nimetus,
              value: maakond.kood,
            };
          }),
        ),
    );
  }, []);

  const getBoroughs = (code: string) => {
    get<AdsBoroughResponseBody>({
      endPoint: "ads",
      queryParams: [{ name: "kood", value: code }], // EHAK kood
    }).then(
      (res) =>
        res.ok &&
        setBoroughs(
          res.body.resultsList.map((vald) => {
            return {
              label: vald.nimetus,
              value: vald.kood,
            };
          }),
        ),
    );
  };

  const getVillages = (code: string) => {
    get<AdsVillageResponseBody>({
      endPoint: "ads",
      queryParams: [{ name: "kood", value: code }], // EHAK kood
    }).then(
      (res) =>
        res.ok &&
        res.body.resultsList.length > 0 &&
        setVillages(
          res.body.resultsList.map((vald) => {
            return {
              label: vald.nimetus,
              value: vald.kood,
            };
          }),
        ),
    );
  };

  const add = (input: Input) => {
    post<UserInterestAreaRequestBody, never>({
      endpoint: "userInterestArea",
      requestBody: {
        ehakKood: input.village?.value || input.borough?.value || input.county.value,
      },
    }).then((res) => {
      if (res.ok) {
        refresh();
        close();
      }
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={close} size="sm">
      <ModalHeader>{t(`${tBase}title`)}</ModalHeader>
      <ReactForm onValidSubmit={(input: Input) => add(input)}>
        <ModalBody>
          <Section hideTitle>
            <SelectField
              labelCol={{ sm: 20, md: 4, lg: 4 }}
              label={t(tBase + InputName.county)}
              name={InputName.county}
              options={counties}
              onChange={(county: Classifier) => {
                if (county) {
                  getBoroughs(county.value);
                } else {
                  setBoroughs(undefined);
                }
                boroughRef.current?.resetValue();
                setVillages(undefined);
                villageRef.current?.resetValue();
              }}
              required
            />
            <SelectField
              labelCol={{ sm: 20, md: 4, lg: 4 }}
              disabled={!boroughs}
              label={t(tBase + InputName.borough)}
              name={InputName.borough}
              options={boroughs}
              onChange={(borough: Classifier) => {
                if (borough) {
                  getVillages(borough.value);
                } else {
                  setVillages(undefined);
                }
                villageRef.current?.resetValue();
              }}
              reference={boroughRef}
            />
            <SelectField
              labelCol={{ sm: 20, md: 4, lg: 4 }}
              disabled={!villages}
              label={t(tBase + InputName.village)}
              name={InputName.village}
              options={villages}
              reference={villageRef}
            />
          </Section>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" type={"submit"}>
            {t("common.add")}
          </Button>

          <Button color="secondary" onClick={close}>
            {t("common.cancel")}
          </Button>
        </ModalFooter>
      </ReactForm>
    </Modal>
  );
};

export default AddInterestAreaModal;
